module.exports = __webpack_public_path__ + "static/media/italic.0557952a.svg";